import { ItemLayoutType } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitTimeKeeping/types';

export const findFreeSpot = (items: ItemLayoutType[], w: number, h: number, cols: number) => {
  const collides = (x: number, y: number) =>
    items.some(it => x < it.x + it.w && x + w > it.x && y < it.y + it.h && y + h > it.y);
  const maxY = items.reduce((acc, it) => Math.max(acc, it.y + it.h), 0);
  for (let y = 0; y <= maxY; y++) {
    for (let x = 0; x + w <= cols; x++) {
      if (!collides(x, y)) return { x, y };
    }
  }

  return { x: 0, y: maxY };
};
